import { render, staticRenderFns } from "./Veranda.vue?vue&type=template&id=3f541550&scoped=true"
import script from "./Veranda.vue?vue&type=script&lang=ts"
export * from "./Veranda.vue?vue&type=script&lang=ts"
import style0 from "./Veranda.vue?vue&type=style&index=0&id=3f541550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f541550",
  null
  
)

export default component.exports